export const API_HOST = process.env.REACT_APP_API_ENTRYPOINT;
export const API_PATH = '/';
